import { render, staticRenderFns } from "./KapakHesabi.vue?vue&type=template&id=70b9d9a4"
import script from "./KapakHesabi.vue?vue&type=script&lang=ts"
export * from "./KapakHesabi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports